import React, { FC, useMemo } from 'react';
import { user } from '../../assets/icons';
import { ClientTypeE, IconColorE, ProjectStatusE, StatusE, UserRoleE } from '../../models/enums';
import showWaitingActionIconFor from '../../utils/conditions/showWaitingActionIconFor';
import Icon from '../Icon/Icon';

type TimerIconPropTypes = {
    statusName: StatusE | ProjectStatusE;
    clientType: ClientTypeE;
    role: UserRoleE;
}

const TimerIcon: FC<TimerIconPropTypes> = (props) => {
    const { statusName, clientType, role } = props;
    const isCLockShown = useMemo(() => showWaitingActionIconFor(role, clientType, [ProjectStatusE[statusName]] as ProjectStatusE[]), [statusName, role, clientType]);

    return isCLockShown ? (
        <Icon name='timer' color={IconColorE.ORANGE} />
    ) : (
        <></>
    );
};

export default TimerIcon;